import { File, type IFileData } from '../File'
import { FileViewerComponents, FileViewer } from '../FileViewer'
import { type IFileViewerProps } from '../FileViewer/FileViewer'
import { useFileViewerContext } from '../FileViewer/FileViewerContext'

export interface ISingleFileViewerProps {
  file: IFileData
  components?: Partial<IFileViewerProps['components']>
}

const ControlsSection = () => {
  const { selectedFile } = useFileViewerContext()

  return selectedFile ? (
    <FileViewerComponents.ControlsSection>
      <File data={selectedFile} border={false} />
    </FileViewerComponents.ControlsSection>
  ) : null
}

export const SingleFileViewer = ({
  file,
  components,
}: ISingleFileViewerProps) => {
  return (
    <FileViewer
      files={file ? [file] : []}
      selectedFile={file}
      components={{
        ...components,
        ControlsSection,
      }}
    />
  )
}
